/*
 * @description: 
 * @Author: WE1ZHANTA0
 * @Creat: 2020-03-04 17:01:19
 * @lastTime: 2020-03-10 11:20:15
 * @LastAuthor: WE1ZHANTA0
 */
import axios from 'axios'
import { Toast } from 'mint-ui'

const Http = (function () {
  const instance = axios.create({
    baseURL: `//${globalConfig.yunjimarketingapp}`,
    withCredentials: true
  })
  
  instance.interceptors.response.use((res) => {
    // if (res.data.errorCode == 2418) {
    //   const returnUrl = window.location.href
    //   let jumpUrl = '//' + window.globalConfig.linkBasePath + '/yunjibuyer/getVueUser.xhtml?returnUrl=' + encodeURIComponent(returnUrl+'&authorize=true')
    //   if (YunJi.getCookie('YUNJI_WEChAT_AYTHOTIZED')) {
    //     window.location.href = jumpUrl
    //   } else {
    //     window.location.href = "//"+ window.globalConfig.linkBasePath + "/basecomponents/weChatAuthorized.html?returnUrl="+encodeURIComponent(jumpUrl) + "&titleName=云集"
    //   }
    //   return
    // }
    return res.data
  }, error => Promise.reject(error))
  return instance
}())

/**
 * 根据用户Id查询TAB列表数据
 * API文档：http://172.16.0.12/showdoc/index.php?s=/52&page_id=7450
 */
export const getMyPrizeList = (params) => Http.get('/yunjimarketingapp/app/gravity/getMyPrizeList.json', { params })